import { render, staticRenderFns } from "./informationDetailsArea.component.vue?vue&type=template&id=2936817e"
import script from "./informationDetailsArea.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetailsArea.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2936817e')) {
      api.createRecord('2936817e', component.options)
    } else {
      api.reload('2936817e', component.options)
    }
    module.hot.accept("./informationDetailsArea.component.vue?vue&type=template&id=2936817e", function () {
      api.rerender('2936817e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/informationDetails/informationDetailsArea.component.vue"
export default component.exports